import { MONTH_DAY_YEAR_FORMAT } from '@/Framework/DateTime/dateFormats';
import { format } from 'date-fns';
import isNumber from 'lodash/isFinite';
import formatNumber from '@/Framework/dataHelpers/formatters/formatNumber';
import { LABEL_FORMAT, STRATS_TABLE_NA_LABEL, CURRENCY_USD_LABEL } from './constants';

export function formatSummary(type: string, value: number) {
  switch (type) {
    case 'date':
      return format(new Date(value), MONTH_DAY_YEAR_FORMAT);
    case CURRENCY_USD_LABEL:
    case 'number':
      return formatNumber(value);
    case '%':
      return `${ formatNumber(value, {
        decimals: 2,
      }) }%`;
    default:
      return value;
  }
}

export function formatColumns(column: string, value: number): string {
  switch (column) {
    case 'acquisitionCostSum':
    case 'baseResidualValueSum':
    case 'reportingPeriodEndActualSecuritizationAmountSum':
    case 'averageESV':
    case 'originalLoanAmountSum':
    case 'reportingPeriodActualEndBalanceAmountSum':
    case 'weightedAverageELA':
      return formatNumber(value);
    case 'leasesCountPercent':
    case 'baseResidualValueSumPercent':
    case 'reportingPeriodEndActualSecuritizationAmountSumPercent':
    case 'weightedAverageLTV':
    case 'loansCountPercent':
    case 'originalLoanAmountSumPercent':
    case 'reportingPeriodActualEndBalanceAmountSumPercent':
    case 'weightedAverageAPR':
      return `${ formatNumber(value, {
        decimals: 2,
      }) }%`;
    case 'weightedAverageRT':
    case 'weightedAverageTerm':
      return formatNumber(value, {
        decimals: 2,
      });
    default:
      return formatNumber(value);
  }
}

/**
 * The checkbox name is formed the following way - 'checkbox-[group id]-[range-id]'.
 * In most case the range id is a 1-3 digits number (e.g. 453 or 23).
 * But for AutoLease - Scheduled Maturity table the range id is being formed dynamically and looks like - '24_2017-06'.
 *
 * So, the logic is:
 * 1. Find the index of the first hyphen in 'checkbox-24-24_2017-06'
 * 2. Find the index of the first symbol after the second hyphen in 'checkbox-24-24_2017-06'
 * 2. Get a substring from 'checkbox-24-24_2017-06' starting from the first symbol after second hyphen
 */
export function getRangeIdFromCheckboxName(field) {
  const indexOfFirstHyphen = field.name.indexOf('-');
  const indexOfTheFirstSymbolAfterSecondHyphen = field.name.indexOf('-', indexOfFirstHyphen + 1);
  const rangeId = field.name.substr(indexOfTheFirstSymbolAfterSecondHyphen + 1);

  return !isNumber(Number(rangeId)) ? rangeId : Number(rangeId);
}

export function getSummaryValue(label: string, value: number) {
  const prefix = LABEL_FORMAT[label] === CURRENCY_USD_LABEL ? LABEL_FORMAT[label] : null;
  const val = value === 0 ? STRATS_TABLE_NA_LABEL : formatSummary(LABEL_FORMAT[label], value);

  return `${ prefix || '' } ${ val !== null ? val : '' }`;
}
